module.exports = __webpack_public_path__ + "public/assets/754056ca23ecf2fa5b2d0e9a6fb953e4.gif";